import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { Router, browserHistory } from 'react-router';
import { syncHistoryWithStore } from 'react-router-redux';
import configureStore from './store';
import routes from './routes';
import './actions/outline';

const initialState = window.__INITIAL_STATE__;
const store = configureStore(browserHistory, initialState);
const history = syncHistoryWithStore(browserHistory, store);

const { basePath } = store.getState();

render(
  <Provider store={store}>
    <Router history={history} routes={routes(basePath)} />
  </Provider>,
  document.getElementById('reactbody')
);

if (module.hot) {
  module.hot.accept();
}

// // TODO add try catch block in case hasGiveWidgetEnabled is false then id will be not present
// if(GiveWidget){
//   new GiveWidget.Create('#giveWidget', '');
// }


